import { render } from "./Header.vue?vue&type=template&id=883f16a8&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=883f16a8&scoped=true&lang=css"

import exportComponent from "/opt/stagecoach/apps/pa-wildflower-selector/deployments/2022-05-18-09-54-08/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-883f16a8"]])

export default __exports__